export { default } from "./DictationBannerView";
